import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ECommerceComponents.css";
import axios from "axios";
import Dropdowncustom from "../../Components/UI-Controls/Dropdown/dropdownaddgeneral1";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { cart_protected_value, product_protected_value, product_protected_value_dual, security_key, Url } from '../../Services/Api';
import { ppValue, paValue } from '../../Services/Env';
import InputIconField from "../UI-Controls/InputField/InputIconField";
import Counter from "../UI-Controls/Counter/Counter";
import { format } from "date-fns";
import { CiWarning } from "react-icons/ci";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoCloseCircle } from "react-icons/io5";

import SectionLoader from "../UI-Controls/MainLoader/SectionLoader";
import { LuUndo2 } from "react-icons/lu";
import generateInvoicePDF from "./orderInvoice";
import generateOrderInvoicePDF from "./orderInvoice2";


const EditOrders2 = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const OrdeR = location.state || {};
    const [loading, setLoading] = useState(false);
    const [loadingNote, setLoadingNote] = useState(false);
    const [summaryloading, setSummaryLoading] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(
        OrdeR.status || "pending"
    );
    const [orderDate, setOrderDate] = useState(
        OrdeR.createdAt ? formatDate(OrdeR.createdAt) : ""
    );
    const [orderNote, setOrderNote] = useState("");
    const [orderNotes, setOrderNotes] = useState([]);
    const [userNote, setUserNote] = useState(OrdeR.customer_note || "");
    const [billingDetails, setBillingDetails] = useState({
        first_name: OrdeR.billing.first_name,
        last_name: OrdeR.billing.last_name,
        address_1: OrdeR.billing.address_1,
        city: OrdeR.billing.city,
        state: OrdeR.billing.state,
        postal_code: OrdeR.billing.postal_code,
        country: OrdeR.billing.country,
        phone: OrdeR.billing.phone,
        email: OrdeR.billing.email,
        _id: OrdeR.billing._id,
    });
    const [shippingDetails, setShippingDetails] = useState({
        first_name: OrdeR.shipping.first_name,
        last_name: OrdeR.shipping.last_name,
        address_1: OrdeR.shipping.address_1,
        city: OrdeR.shipping.city,
        state: OrdeR.shipping.state,
        postal_code: OrdeR.shipping.postal_code,
        country: OrdeR.shipping.country,
        phone: OrdeR.shipping.phone,
        email: OrdeR.shipping.email,
        _id: OrdeR.shipping._id,
    });
    const [items, setItems] = useState(OrdeR.items || []);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const tooltipRefs = useRef([]);
    const modalRef = useRef(null);
    const [margins, setMargins] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const [itemsArray, setItemsArray] = useState(OrdeR.items);
    const [refunded_items, set_refunded_items] = useState(OrdeR?.refund_history);
    const [cartProtected, setCartProtected] = useState(OrdeR.cart_protected);
    const [professionalAssembled, setProfessionalAssembled] = useState(OrdeR.professional_assembled);
    const [furnitureAssembled, setFurnitureAssembled] = useState(OrdeR.furniture_assembled_price ? OrdeR.furniture_assembled_price : 0);
    const [isProtected, setIsProtected] = useState(() => {
        const initialState = {};
        OrdeR.items.forEach((item) => {
            initialState[item._id] = item.is_protected;
        });
        return initialState;
    });
    const [isEditingState, setIsEditingState] = useState({});

    useEffect(() => {
        if (tooltipRefs.current.length > 0) {
            const calculatedMargins = tooltipRefs.current.map((tooltip, index) => {
                if (tooltip) {
                    const lineHeight = 18;
                    const padding = 10;
                    const textHeight = tooltip.scrollHeight;
                    const lines = Math.ceil((textHeight - padding) / lineHeight);
                    return index === 0 ? 75 : 35 + lines * 7;
                }
                return 35;
            });

            setMargins(calculatedMargins);
        }
    }, [orderNotes]);

    const OrderStatusOptions = [
        { value: "pending", label: "Pending" },
        { value: "processing", label: "Processing" },
        { value: "completed", label: "Completed" },
        { value: "cancelled", label: "Canceled" },
        { value: "on-hold", label: "On Hold" },
        { value: "refunded", label: "Refunded" },
        { value: "pending_payment", label: "Pending Payment" },
        { value: "failed", label: "Failed" },
        { value: "draft", label: "Draft" },
        { value: "approved", label: "Approved" },
    ];

    const formatNoteDate = (isoString) => {
        return format(new Date(isoString), "MMMM dd, yyyy 'at' hh:mm a");
    };

    const handleNoteChange = (e) => {
        setOrderNote(e.target.value);
    };

    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };

    useEffect(() => {
        if (showMessage === true) {
            const timeOut = setTimeout(() => {
                setShowMessage(false);
            }, 3000);

            return () => clearTimeout(timeOut);
        }
    }, [showMessage]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBillingDetails({ ...billingDetails, [name]: value });
    };

    const handleChangeShipping = (e) => {
        const { name, value } = e.target;
        setShippingDetails({ ...shippingDetails, [name]: value });
    };

    const handleNameChange = (e) => {
        const [first, ...rest] = e.target.value.split(" ");
        setBillingDetails({
            ...billingDetails,
            first_name: first || "",
            last_name: rest.join(" ") || "",
        });
    };

    const handleCityStateChange = (e) => {
        const [city, ...rest] = e.target.value.split(",");
        setBillingDetails({
            ...billingDetails,
            city: city.trim() || "",
            state: rest.join(",").trim() || "",
        });
    };

    const handleCountryPostalChange = (e) => {
        const [country, ...rest] = e.target.value.split(" ");
        setBillingDetails({
            ...billingDetails,
            country: country.trim() || "",
            postal_code: rest.join(" ").trim() || "",
        });
    };

    const handleUserNoteChange = (e) => {
        setUserNote(e.target.value);
    };

    function formatDate(isoDate) {
        const date = new Date(isoDate);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    }

    const formatPaymentMethod = (method) => {
        if (!method) return "";
        return method
            .replace(/-/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const handleStatusChange = (value) => {
        setSelectedStatus(value);
    };

    /* --- Function to handle submission of updates of Order Details Section --- */
    const updateOrderDetails = async () => {
        setLoading(true);
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };

        let successMessage = "Order details submitted successfully!";
        let warningMessage = "Failed to update order details.";

        try {
            const updatedOrder = {
                ...OrdeR,
                status: selectedStatus,
                customer_note: userNote,
                billing: {
                    ...OrdeR.billing,
                    first_name: billingDetails.first_name,
                    last_name: billingDetails.last_name,
                    address_1: billingDetails.address_1,
                    city: billingDetails.city,
                    state: billingDetails.state,
                    postal_code: billingDetails.postal_code,
                    country: billingDetails.country,
                    phone: billingDetails.phone,
                    email: billingDetails.email,
                    _id: billingDetails._id,
                },
                shipping: {
                    ...OrdeR.shipping,
                    first_name: shippingDetails.first_name,
                    last_name: shippingDetails.last_name,
                    address_1: shippingDetails.address_1,
                    city: shippingDetails.city,
                    state: shippingDetails.state,
                    postal_code: shippingDetails.postal_code,
                    country: shippingDetails.country,
                    phone: shippingDetails.phone,
                    email: shippingDetails.email,
                    _id: shippingDetails._id,
                },
            };

            const response = await axios.put(
                `${Url}/api/v1/orders/edit/${OrdeR._id}`,
                updatedOrder,
                { headers: headers }
            );

            if (response.status === 200) {
                setToastMessage(successMessage);
                setShowMessage(true);

                setTimeout(() => {
                    navigate("/E-Commerce/All-Orders");
                }, 2500);
            }
        } catch (error) {
            console.error("Error updating order:", error);
            setToastMessage(warningMessage);
            setShowMessage(true);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitNote = async () => {
        if (!orderNote.trim()) return;

        let successMessage = "Order note submitted successfully!";
        let warningMessage = "Failed to submit order note.";

        setLoadingNote(true);
        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };

        try {
            const response = await axios.post(
                `${Url}/api/v1/orders/add-note/${OrdeR._id}`,
                { note: orderNote },
                { headers: headers }
            );

            if (response.status === 200) {
                setOrderNotes([...orderNotes, orderNote]);
                setOrderNote("");
                setToastMessage(successMessage);
                setShowMessage(true);
                setTimeout(() => {
                    navigate("/E-Commerce/All-Orders");
                }, 2500);
            }
        } catch (error) {
            console.error("Error adding order note:", error);
            setToastMessage(warningMessage);
            setShowMessage(true);
        } finally {
            setLoadingNote(false);
        }
    };

    useEffect(() => {
        if (OrdeR.order_notes) {
            setOrderNotes(OrdeR.order_notes);
        }
    }, [OrdeR.order_notes]);

    const confirmDelete = (noteId) => {
        setCurrentRowId(noteId);
        setShowConfirm(true);
    };

    const handleDelete = () => {
        console.log(`Deleting order note with ID: ${currentRowId}`);
        if (currentRowId) {
            handleDeleteNote(currentRowId);
        }
    };

    const handleDeleteNote = async (noteId) => {
        if (!noteId) return;

        setIsLoading(true);
        setIsActive(true);

        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };


        try {
            const response = await axios.delete(
                `${Url}/api/v1/orders/delete-note/${OrdeR._id}/${noteId}`,
                { headers }
            );

            if (response.status === 200) {
                setOrderNotes(orderNotes.filter((note) => note._id !== noteId));
                setToastMessage("Order note deleted successfully!");
                setShowMessage(true);
            }
        } catch (error) {
            console.error("Error deleting order note:", error);
            setToastMessage("Failed to delete order note.");
            setShowMessage(true);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
                setIsActive(false);
            }, 5000);
            setShowConfirm(false);
        }
    };

    /* --- Function to Handle Display of Confirmation Dialogue Box of Delete Action --- */
    const handleDeleteClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            cancelDelete();
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleDeleteClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleDeleteClickOutside);
        };
    }, []);

    const cancelDelete = () => {
        setShowConfirm(false);
    };

    /* --- Function to handle Cart Details Item is_protect & protected_price --- */
    const handleProtectedChange = (id) => {
        setIsProtected((prevState) => {
            const updatedState = {
                ...prevState,
                [id]: prevState[id] === 1 ? 0 : 1,
            };

            setItemsArray((prevItems) => {
                return prevItems.map((item) => {
                    if (item._id !== id) return item;

                    const isProtected = updatedState[id];
                    const quantity = Number(item.quantity) || 1;
                    const salePrice = parseFloat(item.sale_price) || 0;

                    const protectedPrice = isProtected
                        ? quantity > 1
                            ? 199
                            : 99
                        : 0;

                    const subTotal = salePrice * quantity;
                    const total = isProtected
                        ? subTotal + protectedPrice * quantity
                        : subTotal;

                    // ✅ If protection was removed, record it in refund items
                    if (!isProtected && item.is_protected === 1) {
                        const refundEntry = {
                            product_id: item.product_id,
                            variation_id: item.variation_id,
                            quantity_refunded: 0,
                            refunded_product: false,
                            refunded_protection: true,
                            protection_refund_amount: item.protected_price * quantity,
                            refunded_assembly: false,
                            assembly_refund_amount: 0,
                        };

                        setPartialRefundedItems((prev) => {
                            const existingItems = [...(prev.items || [])];
                            const existingIndex = existingItems.findIndex(
                                (entry) =>
                                    entry.product_id === refundEntry.product_id &&
                                    entry.variation_id === refundEntry.variation_id &&
                                    entry.refunded_protection
                            );

                            if (existingIndex !== -1) {
                                // Update refund amount if already exists
                                existingItems[existingIndex].protection_refund_amount =
                                    refundEntry.protection_refund_amount;
                            } else {
                                existingItems.push(refundEntry);
                            }

                            return {
                                ...prev,
                                items: existingItems,
                            };
                        });
                    }

                    return {
                        ...item,
                        is_protected: isProtected,
                        protected_price: protectedPrice,
                        sub_total: subTotal,
                        total: total,
                    };
                });
            });

            return updatedState;
        });
    };


    /* --- Function to handle Cart Details Item quantity change --- */
    const handleItemChange = (id, field, value) => {
        setItemsArray((prevItems) => {
            const updatedItems = prevItems.map((item) => {
                if (item._id !== id) return item;

                const updatedItem = { ...item, [field]: value };

                const quantity = field === "quantity" ? Number(value) : Number(updatedItem.quantity);
                const sale_price = parseFloat(updatedItem.sale_price || 0);
                const protected_price = parseFloat(updatedItem.protected_price || 0);

                const sub_total = sale_price * quantity;
                const total = updatedItem.is_protected
                    ? sub_total + protected_price * quantity
                    : sub_total;

                // Check if quantity was decreased
                const originalQty = originalQuantities[id] || 0;
                if (field === "quantity" && quantity < originalQty) {
                    const quantity_refunded = originalQty - quantity;

                    const refundEntry = {
                        product_id: item.product_id,
                        variation_id: item.variation_id,
                        quantity_refunded,
                        refunded_product: true,
                        refunded_protection: item.is_protected === 1,
                        protection_refund_amount: item.is_protected === 1 ? protected_price * quantity_refunded : 0,
                        refunded_assembly: false,
                        assembly_refund_amount: 0,
                    };

                    // Add refund entry to partialRefundedItems
                    setPartialRefundedItems((prev) => {
                        const existingItems = [...(prev.items || [])];

                        const existingIndex = existingItems.findIndex(
                            (item) =>
                                item.product_id === refundEntry.product_id &&
                                item.variation_id === refundEntry.variation_id
                        );

                        if (existingIndex !== -1) {
                            // Update existing quantity_refunded
                            existingItems[existingIndex].quantity_refunded = refundEntry.quantity_refunded;
                            existingItems[existingIndex].protection_refund_amount = refundEntry.protection_refund_amount;
                        } else {
                            // Add new refund entry
                            existingItems.push(refundEntry);
                        }

                        return {
                            ...prev,
                            items: existingItems,
                        };
                    });

                }

                return {
                    ...updatedItem,
                    quantity,
                    sub_total,
                    total,
                };
            });

            return updatedItems;
        });
    };

    const RemoveWholeProduct = (
        removeItem,
        itemToRemove) => {
        // CASE - I : REFUND PRODUCT WITH PROTECTION PLAN : type product
        // CASE - II: REFUND PROTECTION PLAN ONLY : product
        // CASE - III: REFUND ASSEMBLY : cart_protection
        // CASE - IV : REFUND CART PROTECTION : assemly
        setPartialRefundedItems(prev => ({
            ...prev,
            orderId: OrdeR?._id,
        }));
        if (removeItem) {
            const structured_itr = {
                "product_id": itemToRemove?.product_id,
                "price": itemToRemove?.sub_total,
                "variation_id": itemToRemove?.variation_id,
                "quantity_refunded": itemToRemove?.quantity,
                "refunded_product": true,
                "refunded_protection": itemToRemove?.is_protected === 0 ? false : true,
                "protection_refund_amount": itemToRemove?.protected_price,
                "refunded_assembly": false,
                "assembly_refund_amount": 0
            }
            const updatedItems = itemsArray.filter(item => item._id !== itemToRemove._id);
            setItemsArray(updatedItems);
            setPartialRefundedItems(prev => ({
                ...prev,
                items: [...prev.items, structured_itr]
            }));
        }

    };



    useEffect(() => {
    }, [itemsArray]);

    /* --- Function to handle Order Summary Protection Plan & Professional Assembly change --- */
    const handleOrderSummaryChange = (field, value) => {
        if (field === "cart_protected") {
            setCartProtected(value);
            if (value === 1) {
                setPartialRefundedItems(prev => ({
                    ...prev,
                    refundCartProtection: true,
                }));
            }
        } else if (field === "professional_assembled") {
            setProfessionalAssembled(value === 1);
            if (!value) {
                setPartialRefundedItems(prev => ({
                    ...prev,
                    refundAssembly: true,
                }));
            }
        }
    };




    const handleEditClick = (id) => {
        setIsEditingState((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };

    /* --- Function to update Cart Details section Items quantity, is_protected, protected_price and Summary cart_protection & professional_assembly --- */
    const updateCartDetails = async () => {
        setSummaryLoading(true);

        const token = sessionStorage.getItem('authToken');
        const headers = {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };

        let successMessage = "Cart details submitted successfully!";
        let warningMessage = "Failed to update cart details.";

        try {
            const updatedItems = itemsArray.map((item) => ({
                ...item,
                is_protected: isProtected[item._id] || 0,
                protected_price:
                    isProtected[item._id] === 1
                        ? item.quantity === 1
                            ? 149
                            : 199
                        : 0,
            }));

            const updatedTotal = (
                OrdeR.sub_total +
                OrdeR.shipping_cost +
                (cartProtected ? 199 : 0) +
                (professionalAssembled ? 210 : 0) +
                OrdeR.tax -
                OrdeR.discount
            ).toFixed(2);

            const updatedData = {
                ...OrdeR,
                cart_protected: cartProtected ? 1 : 0,
                cart_protection_price: cartProtected ? 199 : 0,
                professional_assembled: professionalAssembled ? 1 : 0,
                professional_assembled_price: professionalAssembled ? 210 : 0,
                items: updatedItems,
                total: updatedTotal,
            };

            console.log("Final API Payload: ", updatedData);

            setItemsArray(updatedItems);

            const response = await axios.put(
                `${Url}/api/v1/orders/edit-order-items/${OrdeR._id}`,
                updatedData,
                { headers: headers }
            );

            if (response.status === 200) {
                setToastMessage(successMessage);
                setShowMessage(true);

                setTimeout(() => {
                    navigate("/E-Commerce/All-Orders");
                }, 2500);
            }
        } catch (error) {
            console.error("Error updating order:", error);
            setToastMessage(warningMessage);
            setShowMessage(true);
        } finally {
            setSummaryLoading(false);
        }
    };



    const processRefund = async () => {
        setLoading(true)
        const token = sessionStorage.getItem('authToken');
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        try {
            const response = await axios.post(
                `${Url}/api/v1/orders/process-refund`,
                {
                    "orderId": OrdeR?._id,
                    "refundAmount": OrdeR?.total,
                    "refundType": "full",
                    "reason": "Customer returned item",
                    "performedBy": "adminUser123"
                }
                ,
                {
                    headers: headers,
                    maxBodyLength: Infinity
                }
            );
            console.log('Refund successful:', response.data);
            setLoading(false)
            alert('Refund processed successfully!');
        } catch (error) {
            console.error('Refund failed:', error);
            alert('Refund failed. Please check console for details.');
            setLoading(false)
        }
    };


    const [partialRefundedItems, setPartialRefundedItems] = useState({
        orderId: "",
        refundType: "partial",
        items: [],
        refundCartProtection: false,
        refundAssembly: false
    });




    const processPartialRefund = async () => {
        setLoading(true)
        const token = sessionStorage.getItem('authToken');
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
        };
        try {
            const response = await axios.post(
                `${Url}/api/v1/orders/process-refund`,
                {
                    orderId: OrdeR?._id, // Replace with your actual orderId
                    refundType: "partial",
                    items: partialRefundedItems.items,
                    refundCartProtection: partialRefundedItems.refundCartProtection,  // or true if needed
                    refundAssembly: partialRefundedItems.refundAssembly,         // or true if needed
                    refundedTax: OrdeR.tax.toFixed(2) - calculateTax(calculateSubTotal(itemsArray), OrdeR?.tax_lines?.tax_rate, professionalAssembled, cartProtected,OrdeR?.shipping_cost)
                },
                {
                    headers: headers,
                    maxBodyLength: Infinity
                }
            );
            console.log('Refund successful:', response.data);
            setLoading(false)
            alert('Refund processed successfully!');
        } catch (error) {
            console.error('Refund failed:', error);
            alert('Refund failed. Please check console for details.');
            setLoading(false)
        }
        // console.log(  {
        //             orderId: OrdeR?._id, // Replace with your actual orderId
        //             refundType: "partial",
        //             items: partialRefundedItems.items,
        //             refundCartProtection: partialRefundedItems.refundCartProtection,  // or true if needed
        //             refundAssembly: partialRefundedItems.refundAssembly,         // or true if needed
        //             refundedTax: OrdeR.tax.toFixed(2) - calculateTax(calculateSubTotal(itemsArray), OrdeR?.tax_lines?.tax_rate,professionalAssembled,cartProtected)
        //         },)
    };

    function calculateSubTotal(items) {
        return items.reduce((acc, item) => {
            const quantity = Number(item.quantity || 1);
            const salePrice = parseFloat(item.sale_price || 0);
            const protectedPrice = parseFloat(item.protected_price || 0);

            let itemSubTotal = 0;

            if (parseInt(item.is_protected) === 1) {
                itemSubTotal = (salePrice * quantity) + protectedPrice;
            } else {
                itemSubTotal = salePrice * quantity;
            }

            return acc + itemSubTotal;
        }, 0);
    }

    // function calculateTax(subtotal, percentage,) {
    //     console.log(subtotal, percentage, "here is pricing")
    //     const tax = (subtotal * parseFloat(percentage)) / 100;
    //     return parseFloat(tax.toFixed(2));
    // }

    function calculateTax(subtotal, percentage, professional_assembled, cart_protected,shipping_cost) {
        const total = subtotal + (professional_assembled === 1 ? paValue : 0) + (cart_protected === 1 ? ppValue : 0) + (furnitureAssembled) + shipping_cost
        const tax = (total * parseFloat(percentage)) / 100;
        return parseFloat(tax.toFixed(2));
    }



    /* --- Function to handle Order Summary total change --- */
    const calculateTotal = () => {
        return (
            calculateSubTotal(itemsArray) +
            OrdeR.shipping_cost +
            (cartProtected === 1 ? paValue : 0) +
            (professionalAssembled === 1 ? ppValue : 0) +
            furnitureAssembled +
            calculateTax(calculateSubTotal(itemsArray), OrdeR?.tax_lines?.tax_rate, professionalAssembled, cartProtected,OrdeR?.shipping_cost) -
            OrdeR.discount
        ).toFixed(2);
    };


    useEffect(() => {
        console.log("Current partialRefundedItems:", partialRefundedItems);
    }, [partialRefundedItems]);

    const [originalQuantities, setOriginalQuantities] = useState({});
    useEffect(() => {
        const quantities = {};
        items.forEach(item => {
            quantities[item._id] = item.quantity;
        });
        setOriginalQuantities(quantities);
    }, [items]);



    return (
        <div className="EditOrderMainPage">

            {(summaryloading || loading || loadingNote) && (
                <div className="backdrop">
                    <SectionLoader />
                </div>
            )}

            <div className="OrderSection-01">
                <div className="RowAlign">
                    {/* Order Edit Page - LeftSide */}
                    <div className="LeftSection">

                        {/* Order Detail Section */}
                        <div className="Order-Leftside">
                            <div className="OrderMainContainer">
                                <span className="Order-Header" style={{ width: "70%" }}>Order Details </span>
                                <div className="invoice_btns_list">
                                    <button style={{ right: "15%" }} onClick={() => {
                                        generateInvoicePDF(OrdeR)
                                    }} className="print_btn_inv">Order Note</button>
                                    <button onClick={() => {
                                        generateOrderInvoicePDF(OrdeR)
                                    }} className="print_btn_inv">Invoice</button>
                                </div>
                            </div>
                            <div className="OrderBodyContainer">
                                <div className="Details-Row-01">
                                    <span>Order Number: {OrdeR.uid}</span>
                                    <span>
                                        Customer IP: {OrdeR.customer_ip_address}
                                    </span>
                                    <span>
                                        {`Payment Via ${OrdeR.payment_method} (${OrdeR.transaction_id})`}
                                    </span>
                                </div>
                                <div className="Details-Row-02">
                                    <div className="RowData-Start-Edit">
                                        <p className="Details-Headings">General Info</p>
                                        <span className="Order-Rendering-Span-Labels">
                                            Date & Time:
                                        </span>
                                        <InputField
                                            type="text"
                                            value={orderDate}
                                            readOnly={true}
                                            height={32}
                                            width={255}
                                        />
                                        <label
                                            style={{
                                                fontFamily: "var(--font-family)",
                                                fontSize: "var(--font-size-small)",
                                                fontWeight: "var(--font-weight-semi-bold)",
                                                lineHeight: "18px",
                                                marginTop: "10px",
                                                marginBottom: "7px",
                                            }}
                                        >
                                            Status:
                                        </label>
                                        <Dropdowncustom
                                            options={OrderStatusOptions}
                                            selected={selectedStatus}
                                            onChange={handleStatusChange}
                                            dropdownClass="custom-dropdown-tax"
                                            dropdownstyle={{ width: "256px" }}
                                            headerborder="var(--standered-border)"
                                            listmaxHeight="160px"
                                            headerheight="32px"
                                            headerBgColor="#FDFDFD"
                                            size={17}
                                        />

                                        {selectedStatus === "refunded" &&
                                            <div className="refund_btns">
                                                <button onClick={() => { processRefund() }}>
                                                    Full Refund
                                                </button>
                                                <button onClick={() => { processPartialRefund() }}>
                                                    Partial Refund
                                                </button>
                                            </div>
                                        }

                                        <label className="Order-Rendering-Labels">
                                            Customer:
                                        </label>
                                        <InputField
                                            type="text"
                                            value={"Guest Checkout"}
                                            readOnly={true}
                                            height={32}
                                            width={255}
                                        />
                                        <label className="Order-Rendering-Labels">
                                            User Note:
                                        </label>
                                        <InputField
                                            type="text"
                                            value={userNote}
                                            onChange={handleUserNoteChange}
                                            height={32}
                                            width={255}
                                        />
                                        <label className="Order-Rendering-Labels">
                                            Payment Method
                                        </label>
                                        <InputField
                                            type="text"
                                            value={formatPaymentMethod(OrdeR.payment_method)}
                                            readOnly={true}
                                            height={32}
                                            width={255}
                                        />
                                    </div>

                                    <div className="RowData-Mid-Edit">
                                        <div className="Main-Details-Heading">
                                            <p className="Details-Headings-Rest">Billing</p>
                                        </div>
                                        <InputField
                                            type="text"
                                            value={`${billingDetails.first_name} ${billingDetails.last_name}`}
                                            onChange={handleNameChange}
                                            height={28}
                                            width={220}
                                        />
                                        <InputField
                                            type="text"
                                            name="address_1"
                                            value={billingDetails.address_1}
                                            onChange={handleChange}
                                            height={28}
                                            width={220}
                                        />
                                        <InputField
                                            type="text"
                                            value={`${billingDetails.city}, ${billingDetails.state}`}
                                            onChange={handleCityStateChange}
                                            height={28}
                                            width={220}
                                        />
                                        <InputField
                                            type="text"
                                            value={`${billingDetails.country} ${billingDetails.postal_code}`}
                                            onChange={handleCountryPostalChange}
                                            height={28}
                                            width={220}
                                        />
                                        <span style={{
                                            marginTop: "10px",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-start"
                                        }}>
                                            <span
                                                style={{
                                                    marginTop: "0px",
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Email
                                            </span>
                                            <span
                                                style={{
                                                    textDecoration: "underline",
                                                    color: "blue",
                                                    cursor: "pointer",
                                                    marginTop: "0px",
                                                }}
                                            >
                                                {OrdeR.billing.email}
                                            </span>
                                        </span>
                                        <span style={{
                                            marginTop: "10px",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-start"
                                        }}>
                                            <span
                                                style={{
                                                    marginTop: "0px",
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Phone No.
                                            </span>
                                            <span
                                                style={{
                                                    marginTop: "2px",
                                                }}
                                            >
                                                <InputField
                                                    type="text"
                                                    name="phone"
                                                    value={billingDetails.phone}
                                                    onChange={handleChange}
                                                    height={28}
                                                    width={220}
                                                />
                                            </span>
                                        </span>
                                    </div>
                                    {OrdeR?.shipping_lines?.method_id !== "METHOD-3" && <div className="RowData-Mid-Edit">
                                        <div className="Main-Details-Heading">
                                            <p className="Details-Headings-Rest">Shipping</p>
                                        </div>
                                        {/* <InputField
                                            type="text"
                                            value={`${billingDetails.first_name} ${billingDetails.last_name}`}
                                            onChange={handleNameChange}
                                            height={28}
                                            width={220}
                                        /> */}
                                        <InputField
                                            type="text"
                                            name="address_1"
                                            value={shippingDetails.address_1}
                                            onChange={handleChangeShipping}
                                            height={28}
                                            width={220}
                                        />
                                        <InputField
                                            type="text"
                                            value={`${shippingDetails.city}, ${shippingDetails.state}`}
                                            onChange={handleCityStateChange}
                                            height={28}
                                            width={220}
                                        />
                                        <InputField
                                            type="text"
                                            value={`${shippingDetails.country} ${shippingDetails.postal_code}`}
                                            onChange={handleCountryPostalChange}
                                            height={28}
                                            width={220}
                                        />

                                        <span style={{
                                            marginTop: "10px",
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            justifyContent: "flex-start"
                                        }}>
                                            <span
                                                style={{
                                                    marginTop: "0px",
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Phone No.
                                            </span>
                                            <span
                                                style={{
                                                    marginTop: "2px",
                                                }}
                                            >
                                                <InputField
                                                    type="text"
                                                    name="phone"
                                                    value={shippingDetails.phone}
                                                    onChange={handleChangeShipping}
                                                    height={28}
                                                    width={220}
                                                />
                                            </span>
                                        </span>
                                    </div>}

                                </div>
                                <div className="Details-Row-03">
                                    <CustomBtn
                                        label={loading ? <div className="btn-loader-Order"></div> : "Save"}
                                        type="button"
                                        onClick={updateOrderDetails}
                                        className="ActionDetailsUpdateBtn"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Cart Details Section */}
                        <div className="Order-Leftside">
                            <div className="OrderMainContainer">
                                <span className="Order-Header" style={{ width: "60%" }}>Cart Details</span>
                                <div className="Order-Header-RightEdit" style={{ gridTemplateColumns: "1fr 1fr 1fr", width: "40%" }}>
                                    <span className="Right-Content-Edit">Cost</span>
                                    <span className="Right-Content-Edit">Qty</span>
                                    <span className="Right-Content-Edit">Total</span>
                                    {/* <span className="Right-Content-Edit">Tax</span> */}
                                    {/* <span className="Right-Content-Edit">Action</span> */}
                                </div>
                            </div>

                            <div className="OrderBodyContainer">
                                {itemsArray.map((item) => {
                                    const allRefundedItems = refunded_items?.flatMap(refund => refund.items) || [];

                                    const refundedItem = allRefundedItems.find(
                                        refunded => refunded.product_id === item.product_id
                                    );

                                    const item_main = items.find(
                                        (protection_item) =>
                                            protection_item.product_id === item.product_id &&
                                            protection_item.is_protected === 1
                                    );
                                    const item_main_1 = items.find(
                                        (other_item) =>
                                            other_item.product_id === item.product_id
                                    );


                                    const refundedQty = refundedItem?.quantity_refunded || 0;
                                    const isRefunded = refundedQty > 0;
                                    const isEditable = item.quantity > refundedQty;

                                    const cost = parseFloat(item.sale_price !== "" ? item.sale_price : item.regular_price);

                                    console.log(isEditable, refundedQty, refundedItem, "hererrer")

                                    return (
                                        <div key={item._id} className="CartSection-Row">
                                            <div className="ImgSection-Edit" style={{ width: "60%" }}>
                                                <img
                                                    src={`${Url + item.image}`}
                                                    alt={item.name}
                                                    className="ImageStyle-Order"
                                                />
                                                <div className="CartDescription-Edit">
                                                    <span className="Main-Headings">{item.name}</span>
                                                    <span className="Headings-1st">SKU: {item.sku}</span>

                                                    {/* Render Attributes */}
                                                    {item.attributes && (
                                                        <div className="AttributesSection-Edit">
                                                            {item.attributes.map((attribute, attrIndex) => (
                                                                <div key={attrIndex} className="AttributeItem">
                                                                    <p className="ItemStyling">
                                                                        {attribute.options[0]?.name || "N/A"}
                                                                    </p>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {/* Protection Plan Checkbox */}
                                                    {item_main && <label className="ItemStyling-1st">
                                                        <input
                                                            type="checkbox"
                                                            checked={isProtected[item._id] === 1}
                                                            onChange={() => handleProtectedChange(item._id)}
                                                            style={{
                                                                marginRight: "5px",
                                                                accentColor: isProtected[item._id] === 1 ? "green" : "gray",
                                                            }}
                                                        //   disabled={!isEditingState[item._id]}
                                                        />

                                                        {console.log(`Item ${item._id} is_protected:`, item.is_protected)}
                                                        {item.quantity > 1 ? `Protected (+$${product_protected_value_dual})` : `Protected (+$${product_protected_value})`}
                                                    </label>}
                                                </div>
                                            </div>



                                            <div className="AmountHandling-Edit" style={{ width: "42%", display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
                                                <div className="Cost" style={{ width: "100%" }}>
                                                    <div >${cost.toFixed(2)}</div>
                                                    {isRefunded && <div style={{ color: "red" }}>-${cost.toFixed(2)}</div>}
                                                </div>

                                                {/* Quantity Counter */}
                                                {isEditingState[item._id] ? (
                                                    <div className="Counter" style={{ width: "100%" }}>
                                                        <Counter
                                                            initialValue={item.quantity}
                                                            limit={item_main_1?.quantity}
                                                            onCounterChange={(newQuantity) =>
                                                                handleItemChange(item._id, "quantity", newQuantity)
                                                            }
                                                            onDelete={() => { RemoveWholeProduct(true, item) }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="Counter" style={{ width: "100%", display: "flex", alignItems: "start", justifyContent: "start" }}>
                                                        <Counter
                                                            limit={item_main_1?.quantity}
                                                            initialValue={item.quantity}
                                                            onCounterChange={(newQuantity) =>
                                                                handleItemChange(item._id, "quantity", newQuantity)
                                                            }
                                                            onDelete={() => { RemoveWholeProduct(true, item) }}
                                                        />
                                                    </div>

                                                )}

                                                <div className="Total" style={{ width: "100%" }}>

                                                    <div >${item.total}</div>
                                                    {isRefunded && <div style={{ color: "red" }} >-${item.total}</div>}

                                                </div>
                                                {/* <div className="Tax">${OrdeR.tax.toFixed(2)}</div> */}

                                                {/* Edit Button */}
                                                {/* {isEditingState[item._id] ? <div><RiDeleteBin6Line onClick={() => { RemoveWholeProduct(item) }} className="deleteIcon" />  <IoCloseCircle onClick={() => { setIsEditingState({}) }} className="deleteIcon" /> </div>: <div className="EditSpan" onClick={() => { isEditable && handleEditClick(item._id) }}>
                          Edit
                        </div>} */}

                                            </div>
                                        </div>
                                    );
                                })}

                                {/* Order Summary */}
                                <div className="CartSection-Row-Summary">
                                    <div className="Order-Total">
                                        <div className="MainContainer">
                                            <span className="Order-Header">Order Summary</span>
                                        </div>

                                        <div className="BodyContainer">
                                            <div className="items-Description">
                                                <span>Sub Total:</span>
                                                <span>${calculateSubTotal(itemsArray)} <del>${OrdeR.sub_total.toFixed(2)}</del></span>
                                            </div>

                                            <div className="items-Description">
                                                <span>Shipping:</span>
                                                {OrdeR?.shipping_lines?.method_id === "METHOD-3" ? <span>Store Pick up </span> : <span>${OrdeR.shipping_cost.toFixed(2)}</span>}
                                            </div>

                                           

                                            {/* Professional Assembly Selection */}
                                            {OrdeR?.shipping_lines?.method_id === "METHOD-3" ?

                                                <div className="items-Description-Summary">
                                                    <label className="Label-Summary">
                                                       
                                                        Furniture Assembly
                                                    </label>
                                                    <span>{`${furnitureAssembled===0 ? "N/A" :`$${furnitureAssembled}`}`}</span>
                                                </div>
                                                : (OrdeR?.shipping_lines?.method_id !== "METHOD-3" && professionalAssembled === 1) ?
                                                <div className="items-Description-Summary">
                                                    <label className="Label-Summary">
                                                        {professionalAssembled === 1 && <input
                                                            type="checkbox"
                                                            checked={professionalAssembled === 1}
                                                            onChange={(e) => handleOrderSummaryChange("professional_assembled", e.target.checked ? 1 : 0)}
                                                            style={{ marginRight: 5 }}
                                                        />}
                                                        White Glove (+${paValue})
                                                    </label>
                                                    <span>${professionalAssembled ? paValue : 0}</span>
                                                </div> :
                                                 <div className="items-Description-Summary">
                                                    <label className="Label-Summary">
                                                    
                                                        Furniture Assembly
                                                    </label>
                                                     <span>{`${furnitureAssembled===0 ? "N/A" :`$${furnitureAssembled}`}`}</span>
                                                </div>
                                            }
                                            {/* Discount */}
                                            <div className="items-Description">
                                                <span>Discount:</span>
                                                <span>{`${OrdeR.discount === 0 ? "N/A" : OrdeR.discount.toFixed(2)}`}</span>
                                            </div>

                                            {/* Tax */}
                                            <div className="items-Description">
                                                <span>Tax:</span>
                                                <span>${calculateTax(calculateSubTotal(itemsArray), OrdeR?.tax_lines?.tax_rate, professionalAssembled, cartProtected,OrdeR?.shipping_cost)} <del>${OrdeR.tax.toFixed(2)}</del></span>
                                            </div>

                                            <div className="RowSeparator-Total"></div>

                                            {/* Grand Total */}
                                            <div className="items-TotalDescription">
                                                <span className="TotalDescription">Grand Total:</span>
                                                <span className="TotalDescription">${calculateTotal()}</span>
                                            </div>

                                            <div className="refund-section-last">

                                            </div>
                                        </div>
                                    </div>
                                    <div className="Order-Total-Btn">
                                        <CustomBtn
                                            label={summaryloading ? <div className="btn-loader-Order"></div> : "Save"}
                                            type="button"
                                            onClick={updateCartDetails}
                                            className="ActionDetailsUpdateBtn"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* Order Edit Page - RightSide */}
                    <div className="RightSection">

                        {/* --- Customer History Section --- */}
                        <div className="Order-Rightside">
                            <div className="OrderMainContainer">
                                <span className="Order-Header">Customer History</span>
                            </div>

                            <div className="OrderBodyContainer">
                                <div className="Customer-History">
                                    <span className="History-Heading">Total Orders</span>
                                    <span className="History-Value">0</span>
                                    <span className="History-Heading">Total Revenue</span>
                                    <span className="History-Value">$0</span>
                                    <span className="History-Heading">Average Order Value</span>
                                    <span className="History-Value">$0</span>
                                </div>
                            </div>
                        </div>

                        {/* --- Order Attribution Section --- */}
                        <div className="Order-Rightside">
                            <div className="OrderMainContainer">
                                <span className="Order-Header">Order Attribution</span>
                            </div>

                            <div className="OrderBodyContainer">
                                <div className="Customer-History">
                                    <span className="History-Heading">Origin</span>
                                    <span className="History-Value">Source: Google</span>
                                    <span className="History-Heading">Device Type</span>
                                    <span className="History-Value">Mobile</span>
                                    {/* <span className="History-Heading">Session Page Views</span>
                  <span className="History-Value">12</span> */}
                                </div>
                            </div>
                        </div>

                        {/* --- Order Status Section --- */}
                        <div className="Order-Rightside">
                            <div className="OrderMainContainer">
                                <span className="Order-Header">Order Status</span>
                            </div>

                            <div className="OrderBodyContainer">

                                {orderNotes?.map((note, index) => (
                                    <div className="Attribution-Row-02" key={index}>
                                        <div
                                            className="RowData-Start-Tooltip"
                                            style={{ marginTop: `${margins[index] || 35}px` }}
                                        >
                                            <div className="TooltipContainer">
                                                <span
                                                    className="TooltipText"
                                                    ref={(el) => (tooltipRefs.current[index] = el)}
                                                >
                                                    {note?.note || "No Note Available"}
                                                </span>
                                                <span
                                                    style={{
                                                        color: "var(--text-color)",
                                                        fontWeight: "var(--font-weight-medium)",
                                                        marginLeft: "15px",
                                                        fontSize: "var(--font-size-small)",
                                                    }}
                                                >
                                                    {note.updatedAt ? formatNoteDate(note.updatedAt) : "Date not available"}
                                                </span>
                                                <span
                                                    style={{
                                                        color: "#C61B1A",
                                                        textDecoration: "underline",
                                                        fontWeight: "var(--font-weight-medium)",
                                                        marginLeft: "55px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => confirmDelete(note._id)}
                                                >
                                                    Delete Note
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* Input Field for Adding Notes */}
                                <div className="Attribution-Row-02">
                                    <div className="RowData-Start">
                                        <InputIconField
                                            placeholder="Enter Order Note Here"
                                            value={orderNote}
                                            name="order_note"
                                            onChange={handleNoteChange}
                                            readOnly={false}
                                            onSubmit={handleSubmitNote}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>

                </div>
            </div>

            {/* --- (PopUp) To Handle Confiramtion for Delete Operation of Order Note --- */}
            {showConfirm && (
                <div className="Delete-Confirmation-Modal">
                    <div className="ModalContent" ref={modalRef}>
                        <CiWarning className="warningIcon" />
                        <div className="deleteHeading">Warning</div>
                        <div className="deleteContent">
                            Are you sure you want to delete this Order Note? <br />
                            This action cannot be undone.
                        </div>
                        <div className="separatorLine"></div>
                        <div className="modalActions">
                            <button
                                className="NoteDelete-btn btnSecondary"
                                onClick={cancelDelete}
                            >
                                Cancel
                            </button>

                            <div className="NoteSubmitBtn">
                                <CustomBtn
                                    label={
                                        isLoading ? (
                                            <div className="btnLoader-Note"></div>
                                        ) : (
                                            "Confirm"
                                        )
                                    }
                                    className={`NoteDeletebtn btnDanger ${isActive ? "active" : ""
                                        }`}
                                    disabled={isLoading}
                                    onClick={handleDelete}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />

        </div>
    );
};

export default EditOrders2;